module.exports = __webpack_public_path__ + "static/media/boy-member-checked.2dd0cc45.svg";